

import React from 'react'
import { FormattedMessage } from 'react-intl'

import PropTypes from 'prop-types'

import * as Util from '../../../Util/util'

import TileInfo from './TileInfo'
import TutorialTileInfo from '../../../../Tutorial/TutorialTilePopup/TileInfo'

import UpgradePanel from './UpgradePanel'
import TutorialUpgradePanel from '../../../../Tutorial/TutorialTilePopup/UpgradePanel'

import MountainInfo from './TileInfo/MountainInfo'

class TilePopup extends React.Component {
  /****/

  constructor(props) {
    super(props)

    const { displayingBuildingCard, buildings, userMap } = props

    let current = buildings[displayingBuildingCard] ? buildings[displayingBuildingCard] : null

    this.state = {
      currentBuilding: current,
      lastBuilding: null,
      shouldNavigateToMining: false,
      selectedType: '',
      switched: false,
      isVoid:
        Object.values(userMap.extraBuildings).filter((exBuilding) => exBuilding == false).length ==
        Object.keys(userMap.extraBuildings).length,
      growOutClass: '',
      hasNavigatedToMining: false,
    }
  }

  //EVENT CALLBACKS
  goBackType() {
    this.setState({
      selectedType: '',
    })
  }

  handleClickType(type) {
    const { buildings } = this.props

    let building = Object.values(buildings)
      .filter((building) => !Util.isBlackListed(building.type))
      .filter((building) => building.type == type)[0]

    this.selectBuilding(building)
    this.selectType(type)
  }

  selectBuilding(building) {
    const { setDisplayingCard, displayingBuildingCard } = this.props
    const { currentBuilding, lastBuilding } = this.state

    this.setState({
      currentBuilding: building,
      lastBuilding: lastBuilding != currentBuilding ? currentBuilding : lastBuilding,
    })
    setDisplayingCard(building && building.id ? building.id : displayingBuildingCard)
  }

  selectType(type) {
    const { switched } = this.state

    if (!switched) {
      this.setState({
        selectedType: type,
      })
    }
  }

  switchSides() {
    const { switched, lastBuilding, isVoid } = this.state
    const { userMap } = this.props

    let extraBuildings = userMap.extraBuildings

    this.setState({
      switched: !switched,
    })
    if (!switched && !isVoid) {
      let extra_key = Object.keys(extraBuildings).find((key) => extraBuildings[key] != false)
      let rewarded_building = Object.assign({}, extraBuildings[extra_key])
      rewarded_building.isFree = true
      rewarded_building.extraBuildingId = extra_key
      this.selectBuilding(rewarded_building)
    } else {
      this.selectBuilding(lastBuilding)
    }
  }

  closePopup() {
    const { clearAllPopups } = this.props

    this.setState({ growOutClass: 'fadeOut--animation' })
    setTimeout(() => {
      clearAllPopups()
    }, 1000)
  }

  //RENDERS

  renderMountainInfo() {
    return <MountainInfo closingAction={() => this.closePopup()} />
  }

  renderBuildingData(building, onList, isTutorial) {
    if (onList) {
      return isTutorial ? (
        <TutorialTileInfo building={building} />
      ) : (
        <TileInfo building={building} />
      )
    } else {
      return isTutorial ? (
        <TutorialUpgradePanel building={building} />
      ) : (
        <UpgradePanel building={building} />
      )
    }
  }

  renderConstructionPanels() {
    const { types, buildings, isTutorial, position } = this.props
    const { currentBuilding, selectedType, switched, isVoid, growOutClass } = this.state

    let isTypeSelected = selectedType != ''
    let filtered_types = Object.keys(types)
      .filter((type) => !Util.isBlackListed(type))
      .sort()
    let active = switched ? 'active' : ''
    let voidClass = isVoid && switched ? 'void' : ''
    let filtered_buildings = Object.values(buildings)
      .filter((building) => !Util.isBlackListed(building.type))
      .filter((building) => building.type == selectedType)

    let displayingPanel = null

    if (!switched) {
      if (isTypeSelected && types[selectedType] > 1) {
        displayingPanel = filtered_buildings.map((building, index) =>
          this.renderMenuBuildingCard(building, index)
        )
      } else {
        displayingPanel = filtered_types.map((type, index) => this.renderType(type, index))
      }
    } else {
      displayingPanel = this.renderRewards()
    }
    const right = position && window.innerWidth / 2 > position.x

    return (
      <div
        className={`panels ${growOutClass} ${!growOutClass ? 'fadeInCenter-animation' : ''} ${
          right ? 'panel--right_' : ''
        }`}
      >
        <div className={'panels--box ' + active + ' ' + voidClass}>
          {this.renderHeader()}
          <div className="panels--body">
            <ul className="list--panel">{displayingPanel}</ul>
            {(!isVoid && switched) || !switched
              ? this.renderBuildingData(currentBuilding, true, isTutorial)
              : null}
          </div>
        </div>
      </div>
    )
  }

  renderType(type, index) {
    const { indicators, types } = this.props
    const { currentBuilding } = this.state

    let type_icon = indicators[type] ? indicators[type].icon : 'icon-cohete'
    let multiple = types[type] > 1

    const events = {
      onClick: () => this.handleClickType(type),
    }

    return (
      <li
        key={type + '_' + index}
        {...events}
        className={'list--panel__item' + (currentBuilding.type == type ? ' active' : '')}
      >
        <div className="panel--text">
          <span className={type_icon}></span>
          <span className="text">
            <FormattedMessage id={`indicators.${type}`} />
          </span>
        </div>
        {multiple ? <div className="icon-arrow-right"> </div> : null}
      </li>
    )
  }

  renderMenuBuildingCard(building, index) {
    const { buildings, playerList } = this.props
    const { switched, currentBuilding } = this.state

    if (Util.isBlackListed(building.name)) {
      return null
    } else {
      let b_config = !building.icon ? buildings[building.name] : null
      let selected = currentBuilding.name == building.name

      return (
        <li
          key={building.name + '_' + index}
          className={'list--panel__item' + (selected ? ' active' : '')}
          onClick={() => this.selectBuilding(building)}
        >
          <div className="panel--text">
            <span className={b_config ? b_config.icon : building.icon}> </span>
            <span className="text">
              <FormattedMessage id={b_config ? b_config.name : building.name} />
              {switched && building.rivalId ? (
                <span className="win">
                  <FormattedMessage
                    id="map.buildings.wonTo"
                    values={{ to: playerList[building.rivalId].colonyName }}
                  />
                </span>
              ) : null}
            </span>
            {building.level && switched ? (
              <span className="level">
                <FormattedMessage id="map.buildings.level" />
                {building.level}
              </span>
            ) : null}
          </div>
        </li>
      )
    }
  }

  renderRewards() {
    const { userMap } = this.props
    const { isVoid } = this.state

    let extraBuildings = userMap.extraBuildings

    if (!isVoid) {
      return Object.keys(extraBuildings).map((key, index) => {
        let building = extraBuildings[key]
        if (building == false) {
          return null
        } else {
          let rewarded_building = Object.assign({}, building)
          rewarded_building.isFree = true
          rewarded_building.extraBuildingId = key
          return this.renderMenuBuildingCard(rewarded_building, index)
        }
      })
    } else {
      return (
        <li className="list--panel__item">
          <div className="icon-desafio"> </div>
          <div className="alert">
            <FormattedMessage id="map.norewards" />
          </div>
        </li>
      )
    }
  }

  renderHeader() {
    const { selectedType, isVoid } = this.state
    const { indicators, types } = this.props

    let type_icon = indicators[selectedType] ? indicators[selectedType].icon : 'icon-cohete'
    let isTypeSelected = selectedType != ''
    let header = (
      <div className="panels--header__block">
        <FormattedMessage id="map.buildings.new" />
        <div className="switch">
          <input type="checkbox" className="input--switch" name="switch" id="switch" />
          <label htmlFor="switch" onClick={() => this.switchSides()}></label>
        </div>
        <div className="rewards-box">
          <FormattedMessage id="map.buildings.rewards" />
          {!isVoid && <span className="notification reward icon-hexagon"></span>}
        </div>
        <span className="icon-cross" onClick={() => this.closePopup()}>
          {' '}
        </span>
      </div>
    )

    if (isTypeSelected && types[selectedType] > 1) {
      header = (
        <div className="panels--header">
          <span className="icon-back" onClick={() => this.goBackType()}>
            {' '}
          </span>
          <span className={type_icon}> </span>
          <FormattedMessage id={`indicators.${selectedType}`} />
          <span className="icon-cross" onClick={() => this.closePopup()}>
            {' '}
          </span>
        </div>
      )
    }

    return <div className="panels--header">{header}</div>
  }

  componentDidUpdate(prevProps) {
    const { selectedBuilding, selectedTile, currentPhase, visitorMap, userMap, groupData, clearAllPopups, addScreen } = this.props
    const { hasNavigatedToMining } = this.state

    // Handle navigation to mining_screen when clicking on mine building in phase 2
    if (selectedBuilding && !groupData.endGame && currentPhase == 2 && selectedBuilding.type == 'mine' && !visitorMap.mapId) {
      // Reset navigation flag if building changed
      if (prevProps.selectedBuilding !== selectedBuilding) {
        this.setState({ hasNavigatedToMining: false })
      }

      // Navigate if we haven't navigated yet for this building
      if (!hasNavigatedToMining) {
        this.setState({ hasNavigatedToMining: true })
        clearAllPopups()
        addScreen('mining_screen')
        return
      }
    } else {
      // Reset flag when conditions no longer met
      if (hasNavigatedToMining) {
        this.setState({ hasNavigatedToMining: false })
      }
    }

    // Check if we should clear popups
    // Only check mountain conditions if selectedTile exists and has the required properties
    const hasADestroyingMountain = selectedTile &&
                                   (visitorMap.removedRocks[selectedTile.q + '_' + selectedTile.r] ||
                                    userMap.removedRocks[selectedTile.q + '_' + selectedTile.r])

    const shouldShowPopup = (selectedBuilding && !groupData.endGame) ||
                           (!groupData.endGame && selectedTile &&
                            (selectedTile.terrain == 'mountain' ||
                             (hasADestroyingMountain && hasADestroyingMountain.destroying != true))) ||
                           (!visitorMap.mapId && currentPhase == 3 && !groupData.endGame)

    if (!shouldShowPopup) {
      // Only clear if conditions changed to avoid infinite loops
      const conditionsChanged = prevProps.selectedBuilding !== selectedBuilding ||
                               prevProps.selectedTile !== selectedTile ||
                               prevProps.currentPhase !== currentPhase ||
                               prevProps.groupData?.endGame !== groupData?.endGame

      if (conditionsChanged) {
        clearAllPopups()
      }
    }
  }

  /**
   *  Render component
   *  @return {React.Component} The component
   */
  render() {
    const {
      selectedBuilding,
      selectedTile,
      currentPhase,
      visitorMap,
      userMap,
      addScreen,
      clearAllPopups,
      isTutorial,
      groupData,
    } = this.props

    // Only check mountain conditions if selectedTile exists and has the required properties
    let hasADestroyingMountain = selectedTile &&
      (visitorMap.removedRocks[selectedTile.q + '_' + selectedTile.r] ||
      userMap.removedRocks[selectedTile.q + '_' + selectedTile.r])
    if (selectedBuilding && !groupData.endGame) {
      // Navigation to mining_screen is handled in componentDidUpdate to avoid setState during render
      if (currentPhase == 2 && selectedBuilding.type == 'mine' && !visitorMap.mapId) {
        return null
      } else {
        return this.renderBuildingData(selectedBuilding, false, isTutorial)
      }
    } else if (
      !groupData.endGame &&
      selectedTile &&
      (selectedTile.terrain == 'mountain' ||
        (hasADestroyingMountain && hasADestroyingMountain.destroying != true))
    ) {
      return this.renderMountainInfo()
    } else if (!visitorMap.mapId && currentPhase == 3 && !groupData.endGame) {
      return this.renderConstructionPanels()
    } else {
      // clearAllPopups() moved to componentDidUpdate to avoid setState during render
      return null
    }
  }
}

TilePopup.propTypes = {
  tileScreen: PropTypes.string,
  currentBuilding: PropTypes.string,
  currentPhase: PropTypes.number,
  clearAllPopups: PropTypes.func,
  setDisplayingCard: PropTypes.func,
  visitorMap: PropTypes.object,
  displayingBuildingCard: PropTypes.string,
  position: PropTypes.object,
  userMap: PropTypes.object,
  buildings: PropTypes.object,
  playerList: PropTypes.object,
  selectedTile: PropTypes.object,
  selectedBuilding: PropTypes.object,
  addScreen: PropTypes.func,
  types: PropTypes.object,
  indicators: PropTypes.object,
  groupData: PropTypes.object,
  isTutorial: PropTypes.bool,
}

export default TilePopup
